// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_AbrirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_AbrirInput — POST /chamados/abrir.
 *
 * ---------------------------------------------------------------------------
 * O LIMITE DE 100 EM `assunto` É DEFESA CONTRA PERDA SILENCIOSA DE DADO
 * ---------------------------------------------------------------------------
 * A coluna é `varchar(100)` e NÃO HÁ como pedir outro tamanho: `Field`
 * (helpers/record_helper.php) tem `private $size = 100` fixo e descarta
 * qualquer tamanho declarado no metadata do Record — medido em 2026-09-01,
 * comparando o metadata com o describe_table depois do migrate.
 *
 * Somado ao `sql_mode` NÃO-ESTRITO de que a plataforma depende (#63), um
 * assunto de 140 caracteres seria TRUNCADO em 100 pelo MySQL SEM ERRO NENHUM:
 * o usuário digita uma frase, salva, e lê outra. Nem ele nem o suporte teriam
 * como saber que faltou pedaço.
 *
 * Por isso o limite é recusa explícita AQUI, com mensagem — nunca corte
 * silencioso lá.
 *
 * `descricao` é `text` e não tem esse problema; o teto existe só para impedir
 * corpo absurdo.
 *
 * ---------------------------------------------------------------------------
 * `franquia_id` VEM DO CLIENTE, E É POR ISSO QUE O CONTROLLER O VERIFICA
 * ---------------------------------------------------------------------------
 * Um funcionário pode estar ligado a mais de uma franquia, então a escolha é
 * legítima e precisa vir da tela. O que NÃO é legítimo é confiar nela: o
 * controller confere contra as franquias da IDENTIDADE do usuário
 * (Permissoes_model), nunca contra o Filtro — ver o docblock de Chamados_model.
 */
import { registerContract } from './validate'

export interface Chamados_AbrirInput {
franquia_id: number
assunto?: string
descricao?: string
prioridade?: string
pagina_uri?: string
os_id?: number
cliente_id?: number
}

registerContract('Chamados_AbrirInput', {
  franquia_id: { type: 'number',  required: true },
  assunto:     { type: 'string',  required: false },
  descricao:   { type: 'string',  required: false },
  prioridade:  { type: 'string',  required: false },
  pagina_uri:  { type: 'string',  required: false },
  os_id:       { type: 'number',  required: false },
  cliente_id:  { type: 'number',  required: false },
})
